import React, { useRef, useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
// import { coinState } from "../../App"; 
import { getData, postData } from "../../Service/ApiMethod";
import { Afterlogin, Beforlogin, RECOMMENDED_CANDIDATES, Recruiter_Create_Message, SearchEvent, Selected_Candidate, UNLOCKED_PROFILES, UNLOCKNOW, Vacancies, vaccancy_url } from "../../Service/service";
import AddToList from "../Vaccancy/AddToList";
import ApplicantsAvailability from "../Vaccancy/ApplicantsAvailability";
import MapView from "./component/MapView";
import RoundsPopup from "./component/RoundsPopup";
import ShareButtons from "./component/ShareButtons";
import TokenwarnPopup from "./component/tokenwarnPopup";
import FilterSearchEvent from './FilterSearchEvent.js'
import { useTranslation } from "react-i18next";


const SearchFilters = (props) => {
  // const [experiance, setExperience] = useState(2);
  // const [distance, setDistance] = useState(12);
  // const [age, setAge] = useState(22);
  // const [salary, setSalary] = useState(3);
  // const [isActive, setIsActive] = useState();
  // const [employeType, setEmployeType] = useState();
  // const [gender, setGender] = useState();
  const [searchValue, setSearchValue] = useState()
  // const [recomended, setRecomended] = useState()
  // const [unlockProfileData, setUnlockProfileData] = useState()
  const [searchData, setSearchData] = useState([])
  const [isError, setIsError] = useState()
  const [contactDetails, setContactDetails] = useState(false)
  const [user_ID, setUser_ID] = useState(0)
  const [vacancyUserID, setVacancyUserID] = useState(0)
  const [vacancy, setVacancy] = useState([])
  const [addtolistPopup, setAddtolistPopup] = useState(false)
  const [showFullDetails, setShowFullDetails] = useState(false)
  const [popupUserid, setPopupUserid] = useState()
  const [singleScreenButton, setSingleScreenButton] = useState()
  const [popupIndex, setPopupIndex] = useState()
  const [showButtons, setShowButtons] = useState(false)
  const [lockdetailsunlock, setLockdetailsunlock] = useState(false)
  const [vacancyPopup, setVacancyPopup] = useState(false)
  const [vacancyIndex, setVacancyIndex] = useState()
  const [singleScreenIndex, setSingleScreenIndex] = useState()
  // const [showOneData, setShowOneData] = useState(true)
  const [searchOk, setSearchOk] = useState(false)
  const searchOkk = useRef(false)
  const [roundPopup, setRoundPopup] = useState(false)
  const [phoneandemail, setPhoneandemail] = useState(false)
  const [roundIndexing, setRoundIndexing] = useState()
  const [tokenwarn, setTokenwarn] = useState(false)
  const [showFilter, setShowFilter] = useState(false)
  const [searchFilterData, setSearchFilterData] = useState()
  const [searchFilterBackupData, setSearchFilterBackupData] = useState([])
  // const [showSharePopup, setShowSharePopup] = useState(false)
  const [candidateMessageData, setCandidateMessageData] = useState()
  const [indexing, setIndexing] = useState()



  const navigate = useNavigate()

  // const updatedCoins = useContext(coinState)
  // console.log('setCreditBalance', updatedCoins)

  const setSearchEvent = props?.setSearchEvent

  console.log('search Data', searchData)
  console.log('searchFilterData', searchFilterData)

  const ref = useRef(null);
  useOutsideAlerter(ref);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {

          setSearchEvent && setSearchEvent(false)
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref])
  }
  const pdf = ''
  console.log('pfffffffffff', pdf)

  const search = (searchFilterData || searchData)?.map((item) => {
    return (item?.license)

  })
  console.log('licenseeeeeed', search)

  const license = (search && search.length > 0) ? search.find(item => item != null) : null;
  console.log('license', license);


  // const pdfUrl = pdf.substring(2, pdf.length - 2);



  // const handleClick = (id) => {


  //   console.log('id', id)


  //   const pdf = id?.substring(2, id.length - 2);

  //   window?.open(pdf, '_blank');


  // };

  const handlechange = () => {
    console.log("checkvalue 000000000000000000",searchValue);
    if (searchValue == undefined) {
      alert("Please Enter A value")
    }
    else {
      setSearchOk(true)
      searchOkk.current = true
    }
    setTimeout(()=>{
console.log(searchOk,"value",searchOkk.current);
    },2000)
  }
  // const loginToken = localStorage.getItem('catzapp_token');


  const handleShare = async (id) => {  
    let _encodedSeekerId = window.btoa(id)
    console.log(_encodedSeekerId, "encoded seekrr")
    if (navigator?.share) {
      navigator?.share({
        title: `Share title`,
        message: `This is share description.`,
        url: `https://recruiter.catzapp.com/`,
      })
        .then(() => console.log('shared sucessfully'))
        .catch(err => {
          console.log('error ', err)
        })
    }


  }

  const searchgetData = () => {
    console.log('.........................searchvalue', searchValue)
    console.log('........................>>>>>>>>', `${SearchEvent}${searchValue}`)
    var request = {
      keyword:searchValue,
      latitude:28.450857,
      longitude:77.074701,
      emp_details_id:0,
      max_distance:0,
      min_experience:0,
      max_experience:0,
      min_salary:0,
      max_salary:0,
      page_num:1
  };
    // getData(`${SearchEvent}${searchValue}`)
    postData(request, SearchEvent)
      .then(response => response.json())
      .then(res => {
        setSearchData(res.data.candidate_list)
        setSearchFilterBackupData(res.data.candidate_list)
        console.log("search profile Data", res.data.candidate_list)
        console.log('licenssee', res?.data?.license)
      })
      .catch((err) => {
        setIsError(err.message);
        console.log(isError);
      })
  }

  const handleContactDetails = (userID) => {
    setContactDetails(!contactDetails)
    setUser_ID(userID)
    const objDataSelectedCondidate = {
      "seeker_id": userID,
      "round_status": "unlocked"
    }
    if (!contactDetails) {
      console.log("applicant id: ", userID)
      const selected_candidate = () => {
        postData(objDataSelectedCondidate, Selected_Candidate)
          .then(response => response.json())
          .then(data => console.log(data))
          .catch((err) => {
            setIsError(err.message);
            console.log(isError);
          })
      }
      const handleVacancy = () => {
        getData(vaccancy_url)
          .then(res => res.json())
          .then(data => {
            console.log("VacnacyData", data.data)
            setVacancy(data.data?.filter((item) => (item?.title)))
          })
      }
      selected_candidate()
      handleVacancy()
    }
  }

  const handleSelectedTitle = (id) => {
    setVacancyUserID(id)
  }

  const handleOK = (index) => {
    if (vacancyUserID !== undefined && vacancyUserID != 'Select Vacancy') {
      const objDataUnlockNow = {
        "jobseeker_id": user_ID,
        "vacancy": vacancyUserID
      }
      // const postOnUnlockNow = () => {
      postData(objDataUnlockNow, UNLOCKNOW)
        .then(response => response.json())
        .then(data => {
          alert(data?.message)
          // updatedCoins(true)
          searchgetData()
          console.log('updatedCoins', data?.data?.amount)
        })
        .catch((err) => {
          setIsError(err.message);
          console.log(isError);
        })
      // }
      // postOnUnlockNow()
      console.log("User_ID", user_ID)
      console.log("vacancyUserID", vacancyUserID)

      setContactDetails(!contactDetails)
      setShowButtons(true)
      setPhoneandemail(true)
      setRoundIndexing(index)
      if (roundPopup) {
        setRoundPopup(false)
      } else {
        setRoundPopup(false)
      }
    } else {
      setContactDetails(false)
      setPhoneandemail(false)
    }

  }

  const gotoSelectHire = (item) => {
    // const setSearchEvent = props?.setPopupValue
    setSearchEvent(false)
    navigate('/hire-details', { state: { item } })
  }
  const handleClose = (i) => {

    let dataClone = [...searchData]
    console.log('dataClone', dataClone)
    dataClone?.splice(i, 1)
    setSearchData([...dataClone])
    console.log('handleClose after click')
    console.log('dataClone', dataClone)
    // }
  }
  const handleMessage = (id) => {
    const obj = {
      "jobseeker_id": id
    }
    postData(obj, Recruiter_Create_Message)
      .then(res => res.json())
      .then(data => {
        console.log('get message candidate response', data?.data)
        setCandidateMessageData(data.data)
        navigate('/message', { state: { data: data?.data } })
      })
      .catch((err) => {
        console.log(err.message)
      })
  }


  useEffect(() => {
    searchgetData()
  }, [searchOk, singleScreenButton,searchOkk.current])

  console.log('setRoundPopup', roundPopup)

  const { t } = useTranslation();

  return (
    <>

      {(searchData?.length > 0) ?
        searchOkk.current &&
        <div className='blur-screen-full-area flex-center blackscreen' style={{ position: 'fixed', top: '0', zIndex: '99999999999999', height: '100vh', background: 'rgb(0, 0, 0, 0.7' }}>
          <div style={{ position: 'unset', marginTop: '7%', zIndex: '999999999999999999999999999', height: '79vh', }} >



            <div style={{ height: '75vh', overflow: 'auto' }} ref={ref} >
              {searchData.length > 0 &&
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '2px 7px' }}>

                  <span style={{ color: 'white', cursor: 'pointer', marginRight: '0' }} onClick={(e) => {
                    e.stopPropagation()
                    setSearchEvent(false)
                  }}>
                    close
                  </span>
                  <img src='../images/filter-icon.png' style={{ cursor: 'pointer', width: '20px', height: '20px', marginLeft: '15px' }} onClick={(e) => {
                    e.stopPropagation()
                    setShowFilter(!showFilter)
                    // setSearchEvent(false)
                  }} />

                </div>}

              {showFilter &&
                <FilterSearchEvent searchFilterBackupData={searchFilterBackupData} setSearchFilterData={setSearchFilterData} setShowFilter={setShowFilter} showFilter={showFilter} />
              }
              {
                (searchFilterData || searchData)?.map((item, index) => {
                  const buttonindexing = index
                  return (
                    <div className="applicants-details-container" style={{ position: 'unset', width: '5rem', zIndex: '99999999999', maxHeight: 'unset', marginBottom: '10px' }} key={index}>
                      <div className="row">
                        <div className="col-10 pl-0">
                          <div className="row d-flex">
                            <div className="map-left mb-3 flex-center relative" >
                              {/** <img src="./images/msg1.png" className="" alt="" />*/}
                              <div class="map-profile">
                              <img src={item?.image || "../images/Vector.png"} className="" alt="" style={{  }} />
                              </div>
                              {/* {item?.is_premium &&
                                <span className="premium" style={{ left: "2px", bottom: "-11px" }}>{('Premium')}</span>} */}
                            </div>
                            <div className="map-right " style={{ }}>
                              <p className="candidate-name" style={{  }}>
                                {(item?.first_name) ? (item?.first_name) : 'Unknown'} {(item?.last_name) ? (item?.last_name) : 'Unknown'}
                              </p>

                              <p className="designation text-white">
                                {item?.profile_title}
                                {/* <span className="transparent-border-btn ml-3">
                              Urgent Vacancy
                            </span> */}
                              </p>
                            </div>
                          </div>
                          {(item?.round_status !== 'LOCKED' || phoneandemail) &&
                            <>
                              <div className="mb-2" style={{ color: 'white' }}>
                                <img className="call-imgg" src='../images/call-reciever.png' alt='img' style={{ marginRight: "10px" }} /> {!(item?.mobile_number?.includes('*')) && (item?.mobile_number)}</div>
                              <div className="d-flex align-items-center" style={{ color: 'white' }}>
                                <img className="call-imgg" src='../images/email.png' alt='img' style={{ marginRight: "10px" }} /> {!(item?.email?.includes('*')) && (item?.email)}</div>
                            </>
                          }

                          {(item?.short_description) ?
                            <p className="heading h5 mt-2 text-white">
                              {(item?.short_description)} </p>
                            : ''}
                          <p className="sub-heading text-white font-12 mt-2">
                            {t('About Me')}
                          </p>
                          <p className="text-white text break-para">
                            {item?.cover_latter}

                          </p>
                          <p className="sub-heading text-white font-12 mt-2">
                            {t('Experience')}
                          </p>
                          {/* <p className="text-white text">

                            {item?.experience_det[0]?.experience} {item?.experience_det[0]?.experience > 1 ? `${t('Years')}` : `${t('Year')}`} {t('of Experience')}
                          </p> */}

                          <p className="sub-heading text-white font-12 mt-2">
                            {t('Type of employment contract')}
                          </p>
                          <p className="text-white text">
                            {item?.employment_type}
                            {(parseInt(item?.availability)) > 0 &&
                              <span className="text-warning text-bold">
                                ({t('Available')} {item?.availability})
                              </span>
                            }

                          </p>
                          <p className="sub-heading text-white font-12 mt-2">{t('Expected Salary')}</p>
                          <p className="text-white text">
                            {item?.currency} {item?.expected_salary} {item?.compensation_details}
                          </p>

                          {/* <p className="sub-heading text-white font-12 mt-2">
                        Current Location
                      </p>
                      <p className="text-white text">INDIA</p> */}

                          {/* <p className="sub-heading text-white font-12 mt-2">
                        About Compny
                      </p>
                      <p className="text-white text">
                        Lorem ipsum dolor sit amet, consectadipiscing elit, sed do
                        eiusmsit at,consectetur adipiscing eliem Lorem ipsum dolor
                        sit amet, consectetur adipiscing elit, sed do eiusm
                      </p> */}



                          {!(popupIndex == index) && !showFullDetails &&
                            <button className="jobseeker-btn mt-3" style={{ backgroundColor: 'blue' }} onClick={(e) => {
                              e.stopPropagation()
                              setPopupUserid(item?.user)
                              setPopupIndex(index)
                              if (popupIndex == index) {
                                setShowFullDetails(true)
                                
                              }
                            }}>
                              {t('See Full Details')}
                            </button>
                          }

                        </div>
                        <div className="col-2 px-0">
                          <div className=" flex-column sticky-top">
                            <div className="white-circle flex-center flex-column">
                              <p className="font-8">{parseInt(item?.percentage_match)}%</p>
                              <p className="font-8">{t('Match')}</p>
                            </div>
                            <div className="white-circle flex-center" onClick={(e) => {
                              if (item?.round_status !== 'LOCKED') {
                                (buttonindexing == index) &&
                                  e.stopPropagation()
                                setRoundPopup(true)
                                console.log('new condition')
                                setRoundIndexing(index)
                              } else {
                                (!phoneandemail &&
                                  alert('Please unlock profile first'))
                                if (roundIndexing == index) {
                                  setRoundPopup(true)
                                }
                              }

                              // if(item?.round_status!=='LOCKED'){
                              //   if(buttonindexing==index){
                              //     setRoundPopup(true)
                              //     console.log('new condition')
                              //     setRoundIndexing(index)
                              //   }
                              // }else{
                              // (!phoneandemail &&
                              //   alert('Please unlock profile first'))
                              // if(roundIndexing==index){
                              // setRoundPopup(true)
                              // }
                              // }
                            }}>
                              <img src="./images/bookmark.png" alt="" />
                            </div>
                            <div className="white-circle flex-center" onClick={(e) => {
                              e.stopPropagation()
                              setIndexing(index)

                              setAddtolistPopup(true)
                            }}
                            >
                              <img className="send-job" src="./images/send-job.png" alt="" style={{ cursor: "pointer" }}/>
                            </div>
                            {(addtolistPopup && indexing == index) && <AddToList setAddtolistPopup={setAddtolistPopup} seekerID={item?.user} />}
                            {/* <div className="white-circle flex-center" >
                          <img src="./images/share-icon.png" alt="" />
                        </div> */}
                            <div className="white-circle flex-center" onClick={(e) => {
                              e.stopPropagation()
                              console.log(item,"okkkkkkkkkkaaaaaaaaaa")
                              // setShowSharePopup(!showSharePopup)
                              handleShare(item?.user)
                            }}>
                              <img src="./images/share-icon.png" alt="" />
                            </div>

                            {(item?.round_status !== 'LOCKED' ? '' :
                              (roundIndexing !== index)) &&
                              <div className="jobseeker-circle flex-center" onClick={(e) => {
                                e.stopPropagation()
                                setVacancyPopup(true)
                                setLockdetailsunlock(true)
                                handleContactDetails(item?.user)
                                setVacancyIndex(index)
                              }}
                                style={{ background: 'blue' }}>
                                <img src="../images/unlcoked-profile-white.png" alt="" />
                              </div>}

                            {/*<div
                          className="red-circle flex-center"
                          onClick={props.closePopup}
                        >
                          <img src="./images/cross.png" alt="" />
                        </div>*/}
                            {(item?.round_status !== 'LOCKED') &&
                              <div className="white-circle flex-center" onClick={(e) => {
                                e.stopPropagation()
                                handleMessage(item?.user)
                              }} >
                                <img  className='msg-icon' src="../images/messages.png" alt="" />
                              </div>
                            }

                            <div
                              className="red-circle flex-center"
                              onClick={(e, index) => {
                                e.stopPropagation()
                                setSingleScreenIndex(index)
                                setPopupIndex(index)
                                handleClose(index)
                                if (singleScreenIndex == index) {
                                  searchData.splice(index, 1)
                                }
                                // setShowOneData(false)
                              }}
                            >
                              <img src="./images/cross.png" alt="" />
                            </div>

                            {/* {showButtons && (singleScreenButton == index) && (
                                <div className="yellow-circle flex-center flex-column" onClick={(e) => {
                                    e.stopPropagation()
                                    gotoSelectHire(item)
                                }}>
                                    <p className="font-12">Hire</p>
                                </div>
                                )} */}
                            {(item?.round_status !== 'LOCKED') && (
                              (buttonindexing == index) &&
                              <div className="yellow-circle flex-center flex-column" onClick={(e) => {
                                e.stopPropagation()
                                gotoSelectHire(item)
                              }}>
                                <p className="" style={{  fontWeight: "bold" }}>{t('Hire')}</p>
                              </div>)}
                            {/* <div
                          className="red-circle flex-center"
                          onClick={(e)=>{
                          e.stopPropagation()
                            handleClose()
                          }}
                        >
                          <img src="./images/cross.png" alt="" />
                        </div>
                        
                        <div className="yellow-circle flex-center flex-column" onClick={(e) => {
                          e.stopPropagation()
                          gotoSelectHire(item)}}>
                          <p className="font-12">Hire</p>
                        </div> */}

                          </div>
                        </div>
                      </div>

                      {contactDetails ?
                        vacancyPopup ?
                          (vacancyIndex == index) &&
                          <div className="blur-screen-full-area inner-modal flex-center">
                            <div className="form-container d-flex flex-column align-items-center my-3"
                              style={{  }} >
                              {/* <div className="form-container my-3" style={{ position: 'fixed', right: '15%', top: '50%' }}  > */}
                              <select name='Select Vacancy' onChange={(e) => handleSelectedTitle(e.target.value)}>
                                <option value='Select Vacancy' default>{t('Select Vacancy')}</option>
                                {vacancy?.map((item) =>
                                  <option key={item?.id} value={item?.id} >{item?.title.substring(0, 50)}</option>
                                )}
                              </select>
                             <div className="mt-3">
                             <button
                                // style={{ marginLeft: '10px', borderRadius: '5px' }}
                                className="btn-primary"
                                style={{ marginLeft: '10px', borderRadius: '5px' }}
                                onClick={(e) => {
                                  e.stopPropagation()
                                  setTokenwarn(true)
                                  // setSingleScreenButton(index)
                                  // handleOK(index)
                                }}
                              >{t('Ok')}</button>
                              <button
                                className=" btn-secondary"
                                style={{ marginLeft: "2px", borderRadius: "5px" }}
                                onClick={(e) => {
                                  e.stopPropagation()
                                  setContactDetails(false)
                                  setVacancyPopup(false)
                                }}>{t('Close')}</button>
                             </div>
                            </div>
                            {tokenwarn &&
                              <TokenwarnPopup
                                setTokenwarn={setTokenwarn}
                                // setPermission={setPermission}
                                message={t('Are you sure to unlock the profile')}
                                handleOK={() => handleOK(index)}
                                setSingleScreenButton={() => setSingleScreenButton(index)}
                              />
                            }
                          </div> : '' : ''}

                      <div className="applicants-distance">
                        <p className="distance-text">
                          <img
                            src="./images/location.png"
                            className=" img-size16"
                            alt=""
                          />
                          {parseInt(item?.distance)} {t('KM Away')}
                        </p>
                      </div>
                      {/* && showFullDetails */}
                      {(popupUserid == item?.user) &&
                        <div>
                          <div style={{ marginTop: '-20px', marginBottom: '10px' }}>
                            <p className="sub-heading text-white font-12 mt-2">{t('Skills')}</p>
                            {/* {item?.skill_set?.map((skill, i) => {
                              return (
                                <div className=" " key={i} style={{ display: "inline-block", marginBottom: '5px' }} >
                                  {skill?.skill_name && <span className="transparent-border-btn">
                                    {skill?.skill_name}</span>}
                                </div>
                              )
                            })} */}
                            <p className="sub-heading text-white font-12 mt-2">
                              {t('Education')}
                            </p>
                            <div>

                              {/* {item?.highest_education_det?.map((item, i) => {
                                return (
                                  <span className="transparent-border-btn" key={i}>
                                    {item?.degree}
                                  </span>
                                )
                              })} */}

                            </div>

                            <p className="sub-heading text-white font-12 mt-2">
                              {t('Passout Year')}
                            </p>
                            <div>
                              <span className="transparent-border-btn">
                                {item?.passout_year}
                              </span>
                            </div>
                            {
    item?.license != [] ? (<>
    <p className="sub-heading text-white font-12 mt-2">
                                        {t('Licenses')}
                                    </p>
                                    {
                                       item?.license.map((item,i)=>(
                                        <div>
                                        <span className="transparent-border-btn"
                                onClick={()=>{
                                    const pdfUrl = item?.license[i];
                                    const cleanedUrl = pdfUrl.replace(/"/g, '');
                                    console.log(cleanedUrl,"pdfUrl")
                                    window.open(cleanedUrl, '_blank');
                                }}
                                 >
                                  license {i+1}
                                </span>
                                        {/* <span className="transparent-border-btn">
                                    {t('License Name 2')}
                                </span> */}
                                    </div>
                                       )) 
                                    }
    </>):null
}
                            {/* <div>
                              <span className="transparent-border-btn"
                                onClick={() => handleClick(item?.license)}>

                                {('Licenses')}
                              </span>

                            </div> */} 
                            {
    item?.certificate != [] ? (<>
    <p className="sub-heading text-white font-12 mt-2">
                                        {t('certificate')}
                                    </p>
                                    {
                                       item?.certificate.map((item,i)=>(
                                        <div>
                                        <span className="transparent-border-btn"
                                onClick={()=>{
                                    const pdfUrl = item?.certificate[i];
                                    const cleanedUrl = pdfUrl.replace(/"/g, '');
                                    console.log(cleanedUrl,"pdfUrl")
                                    window.open(cleanedUrl, '_blank');
                                }}
                                 >
                                  certificate {i+1}
                                </span>
                                        {/* <span className="transparent-border-btn">
                                    {t('License Name 2')}
                                </span> */}
                                    </div>
                                       )) 
                                    }
                                   
    </>):null
}

                            {(item?.round_status === 'LOCKED') ? <div className="mt-4">
                              <span className="transparent-border-btn px-3">
                                <img
                                  src="./images/lock-white.png"
                                  className="mr-2"
                                  alt=""
                                />
                                {t('Contact Details Locked')}
                              </span>
                            </div> : ''
                            }
                          </div>
                          {/* <div style={{ marginLeft: '-15px' }}>
                            <ApplicantsAvailability searchItem={item} />
                          </div> */}
                          <div style={{ width: '111%', marginLeft: '-15px', marginTop: '-9px', marginBottom: '-10px' }}>
                            <MapView mapHeight='400px' userLocation={item} />
                          </div>
                        </div>
                      }
                      {/* {roundPopup && roundIndexing==index && phoneandemail &&
                    <RoundsPopup seekerID={item?.user} setRoundPopup={setRoundPopup} />
                } */}
                      {roundPopup && roundIndexing == index &&
                        <RoundsPopup name={item?.first_name} seekerID={item?.user} setRoundPopup={setRoundPopup} />
                      }
                    </div>
                  )
                })
              }
            </div>
          </div>
        </div> : ''
      }
      <div
        className="blur-screen-full-area flex-center"

        onClick={(e) => {
          e.stopPropagation()
          // props?.outsideTouch()
        }}
      >
        <div className="search-events" ref={ref}>
          <div className="search-filters"
          // onClick={(e)=>{e.stopPropagation()
          //                 props?.insideClick()
          //                 }}

          >
            <h2 className="heading mb-3 text-center">{t('Search Candidates')}</h2>
            <div className="search-container flex-center relative  mb-2">
              <input
                type="text"
                placeholder={t("Search by Candidates/categories/Services")}
                className="search-input"
                style={{ border: "1px solid grey" }}
                onChange={(e) => setSearchValue(e.target.value)}
                onKeyDown={e => e.key === 'Enter' ? handlechange() : ''}
              />
              <img  src="./images/search.png" alt="search" onClick={(e) => {
                e.stopPropagation()
                handlechange()
              }} style={{ cursor: 'pointer' }}
              className="searchIcon searchiconheader"

              />
            </div>

            {/*<p className="popup-heading">Looking</p>

            <div className="looking-keys mt-1 mb-3">
              <button
                className={
                  isActive === "plumber" ? "theme-btn" : "theme-btn deactive-tags"
                }
                style={{ fontSize: "12px" }}
                id="plumber"
                onClick={(e) => setIsActive(e.target.id)}
              >
                Plumber
              </button>
              <button
                className={
                  isActive === "Painter" ? "theme-btn" : "theme-btn deactive-tags"
                }
                style={{ fontSize: "12px" }}
                id="Painter"
                onClick={(e) => setIsActive(e.target.id)}
              >
                Painter
              </button>
              <button
                className={
                  isActive === "Carpainter"
                    ? "theme-btn"
                    : "theme-btn deactive-tags"
                }
                style={{ fontSize: "12px" }}
                id="Carpainter"
                onClick={(e) => setIsActive(e.target.id)}
              >
                Carpainter
              </button>
              <button
                className={
                  isActive === "Driver" ? "theme-btn" : "theme-btn deactive-tags"
                }
                style={{ fontSize: "12px" }}
                id="Driver"
                onClick={(e) => setIsActive(e.target.id)}
              >
                Driver
              </button>
              <button
                className={
                  isActive === "Technican"
                    ? "theme-btn"
                    : "theme-btn deactive-tags"
                }
                style={{ fontSize: "12px" }}
                id="Technican"
                onClick={(e) => setIsActive(e.target.id)}
              >
                Technican
              </button>
              <button
                className={
                  isActive === "Nurse" ? "theme-btn" : "theme-btn deactive-tags"
                }
                style={{ fontSize: "12px" }}
                id="Nurse"
                onClick={(e) => setIsActive(e.target.id)}
              >
                Nurse
              </button>
              <button
                className={
                  isActive === "Construction"
                    ? "theme-btn"
                    : "theme-btn deactive-tags"
                }
                style={{ fontSize: "12px" }}
                id="Construction"
                onClick={(e) => setIsActive(e.target.id)}
              >
                Construction
              </button>
              <button
                className={
                  isActive === "Electrician"
                    ? "theme-btn"
                    : "theme-btn deactive-tags"
                }
                style={{ fontSize: "12px" }}
                id="Electrician"
                onClick={(e) => setIsActive(e.target.id)}
              >
                Electrician
              </button>
            </div>

            <select name="" id="" className="select-input w-100 mb-3">
              <option value="Plumbing">Select Required Skills *</option>

              <option value="Plumbing">Plumbing</option>
              <option value="Plumbing">Painting</option>
              <option value="Plumbing">Building Plumbering</option>
            </select>

            <p className="popup-heading">Type of employment contract</p>

            <div className="looking-keys my-3">
              <button
                className={
                  employeType === "part_time"
                    ? "theme-btn"
                    : "theme-btn deactive-tags"
                }
                style={{ fontSize: "12px" }}
                id="part_time"
                onClick={(e) => setEmployeType(e.target.id)}
              >
                Part Time
              </button>
              <button
                className={
                  employeType === "full_time"
                    ? "theme-btn"
                    : "theme-btn deactive-tags"
                }
                style={{ fontSize: "12px" }}
                id="full_time"
                onClick={(e) => setEmployeType(e.target.id)}
              >
                Full Time
              </button>

              <button
                className={
                  employeType === "contract"
                    ? "theme-btn"
                    : "theme-btn deactive-tags"
                }
                style={{ fontSize: "12px" }}
                id="contract"
                onClick={(e) => setEmployeType(e.target.id)}
              >
                Contract
              </button>
            </div>

            <p className="popup-heading">Gender</p>

          <div className="looking-keys my-3">
            <button
              className={
                gender === "Male" ? "theme-btn" : "theme-btn deactive-tags"
              }
              style={{ fontSize: "12px" }}
              id="Male"
              onClick={(e) => setGender(e.target.id)}
            >
              Male
            </button>
            <button
              className={
                gender === "Female" ? "theme-btn" : "theme-btn deactive-tags"
              }
              style={{ fontSize: "12px" }}
              id="Female"
              onClick={(e) => setGender(e.target.id)}
            >
              Female
            </button>
          </div>*/}

            {/*<div className="range-box mb-3">
              <div className="space-between d-flex">
                <p className="popup-heading">Experience</p>
                <p className="range-details">
                  {" "}
                  {Number(experiance)}-{Number(experiance) + Number(2)} Years
                </p>
              </div>
              <input
                type="range"
                name="experience"
                id="experience"
                min="0"
                max="25"
                value={experiance}
                className="w-100 mt-3"
                onChange={(e) => setExperience(e.target.value)}
              />
            </div>*/}
            {/*<div className="range-box mb-3">
              <div className="space-between d-flex">
                <p className="popup-heading">Maximum Distance</p>
                <p className="range-details"> {Number(distance)} KM</p>
              </div>
              <input
                type="range"
                name="distance"
                id="distance"
                min="0"
                max="100"
                value={distance}
                className="w-100 mt-3"
                onChange={(e) => setDistance(e.target.value)}
              />
            </div>*/}
            {/* <div className="range-box mb-3">
              <div className="space-between d-flex">
                <p className="popup-heading">Age</p>
                <p className="range-details">
                  {" "}
                  {Number(age)}-{Number(age) + Number(2)} Years
                </p>
              </div>
              <input
                type="range"
                name="age"
                id="age"
                min="18"
                max="58"
                value={age}
                className="w-100 mt-3"
                onChange={(e) => setAge(e.target.value)}
              />
            </div>*/}
            {/*<div className="range-box mb-3">
              <div className="space-between d-flex">
                <p className="popup-heading">Salary</p>
                <p className="range-details">
                  {" "}
                  {Number(salary)}k-{Number(salary) + Number(2)}k
                </p>
              </div>
              <input
                type="range"
                name="salary"
                id="salary"
                min="2"
                max="99"
                value={salary}
                className="w-100 mt-3"
                onChange={(e) => setSalary(e.target.value)}
              />
            </div>*/}
            {/*<p className="popup-heading">Candidate Type</p>

            <div className="d-flex horizontal-center my-2">
              <input
                type="checkbox"
                style={{ color: "#96989A" }}
                className="mr-1"
                name=""
                id=""
              />
              <p className="text mr-4" style={{ color: "#96989A" }}>
                Free
              </p>
              <input
                type="checkbox"
                className="mr-1"
                name=""
                id=""
                style={{ color: "#96989A" }}
              />

              <p className="text mr-4" style={{ color: "#96989A" }}>
                Verified
              </p>
              <input
                type="checkbox"
                className="mr-1"
                name=""
                id=""
                style={{ color: "#96989A" }}
              />

              <p className="text mr-4" style={{ color: "#96989A" }}>
                Premium
              </p>
            </div>
            <hr className="line" />

            <button className="theme-btn btn-block">Serch Now</button>*/}
          </div>
        </div>
      </div>
    </>
  );
};

export default SearchFilters;
